import { Permissions } from "@cnx/common";
import { ReactElement } from "react";
import { Navigate } from "react-router";
import { isHasRequiredRights } from "utils/rights";
import { useAuthStore } from "../../stores/authStore";

interface PrivateRouteProps {
  children: ReactElement | null;
  rights: Permissions[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ rights, children }) => {
  const userRights = useAuthStore(state => state.useRights);

  if (!isHasRequiredRights(userRights, rights)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
